import React from 'react';

const Plus = ({width, height, color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.55534 1.40741V10.7407M0.888672 6.07408H10.222" stroke={color || '#6E6C6C'} strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};
export default Plus;
